const articleTag = document.querySelector('#inner-blog-featured-collection[data-tag]');

if(articleTag && articleTag.dataset.tag) {
  class ArticleProductLists extends HTMLElement {
  
  constructor() {
    super();
  }

  connectedCallback() {
      const blogSection = document.querySelector(".blog-featured-collection");
  const blogHTML = blogSection ? blogSection.innerHTML : "";
    this.innerHTML = blogHTML;
    blogSection.style.display = "none";
  }

  disconnectedCallback() {
  }

}

customElements.define(`${articleTag.dataset.tag}`, ArticleProductLists);
}
